import { leaderboardUsers } from "@/models/leaderboardUser.model";
import { doc, getDoc } from "firebase/firestore";

import { firestore } from "../../api/firebaseConfig";

export async function getProfileBasedOnUid(
  uid: string,
  tenantId: string
): Promise<leaderboardUsers["profile"] | undefined> {
  const userNameDocRef = doc(firestore, "profiles", tenantId, "records", uid);
  const userNameDoc = await getDoc(userNameDocRef);
  return userNameDoc.data() as leaderboardUsers["profile"] | undefined;
}
